import React, { useState, useEffect } from "react";
import Select from "react-select";
import OVP from "./ovp";
import JWSection from "./jw";
import LabelImage from "../cards/image";
import YouTube from "./youtube";
import Loader from "../loader/loader";
// import { UserLang } from "../../store/userStore";

const VCMSCard = (props) => {
  const [vcms, setvcms] = useState([]);
  const [lan] = useState("ltr");
  const [loading, setLoading] = useState(true);
  // const lan = UserLang.useState((s) => s.lan);
  /*   const [modalShow, setModalShow] = useState(false);
  const [allImage,setallImage] = useState([]);
  const [pageModalShow, setPageModalShow] = useState(false);
  */
  const option = [
    {
      value: "JWPlayer",
      label: (
        <LabelImage
          url={
            "https://upload.wikimedia.org/wikipedia/en/thumb/6/69/JW_Player_logo.png/330px-JW_Player_logo.png"
          }
          height={"30px"}
        >
          {" "}
        </LabelImage>
      ),
    },
    {
      value: "YouTube",
      label: (
        <LabelImage
          url={
            "https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_Logo_2017.svg"
          }
          height={"30px"}
        >
          {" "}
        </LabelImage>
      ),
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, [2000]);
  }, [vcms]);

  const vcmsChange = (value) => {
    setvcms(value);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Video Cloud Account
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          {lan === "rtl" && <div className="col-md-4"></div>}
                          <div
                            className="col-md-8 float-right"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Video Cloud
                            </label>
                            <Select
                              name="videocloud"
                              className="form-control inside-select float-right"
                              options={option}
                              onChange={vcmsChange}
                            ></Select>
                          </div>
                          <div className="col-md-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {vcms.value === "JWPlayer" ? (
                    <JWSection type={vcms.value}></JWSection>
                  ) : vcms.value === "YouTube" ? (
                    <YouTube type={vcms.value}></YouTube>
                  ) : vcms.value === "Brightcove" ||
                    vcms.value === "Bitmovin" ? (
                    <OVP type={vcms.value}></OVP>
                  ) : vcms.value === "Brightcove" ||
                    vcms.value === "Bitmovin" ? (
                    <OVP type={vcms.value}></OVP>
                  ) : (
                    ""
                  )}
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default VCMSCard;
